import React from 'react';
import { Page } from '../Page';
import { SupplementCallout } from '../SupplementCallout';
export function PageChronicSideEffects() {
  return <Page pageNumber={35} variant="light" data-id="element-1281" data-mp="1f1hg2colbrto">
      <div className="flex flex-col h-full" data-id="element-1282" data-mp="10dmkmoj779cw">
        <div className="mb-8 pt-4" data-id="element-1283" data-mp="10ctnmfa1jy7y">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1284" data-mp="15cg36vdcdqjx">
            Side Effects
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1285" data-mp="rcez771s6308">
            Chronic <span className="text-tealslate" data-id="element-1286" data-mp="wcaxcpnsr07v">Side Effects</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1287" data-mp="heij00tzkhv9" />
        </div>

        <div className="mb-8" data-id="element-1288" data-mp="hgbmx8d7snzk">
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-2xl" data-id="element-1289" data-mp="mdljr92xo1xf">
            While nausea and diarrhea usually fade as your body adapts to the
            medication, other side effects can persist or develop over time.
            These require ongoing management.
          </p>
        </div>

        {/* Mid-page Image Break */}
        <div className="h-[180px] -mx-12 mb-10 overflow-hidden relative" style={{
        width: 'calc(100% + 96px)'
      }} data-id="element-1290" data-mp="fwazioii8b57">
          <img src="https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=1000&q=80" alt="Wellness" className="w-full h-full object-cover" data-id="element-1291" data-mp="pmw36qd1c5uz" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-1292" data-mp="3t3cnvuyiozxb">
          <div data-id="element-1293" data-mp="3t5yu9r9o99dy">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3" data-id="element-1294" data-mp="3o4rm3r3ma86r">
              Hair Loss
            </h2>
            <p className="text-xs text-[#7A7A70] leading-[1.8] mb-4" data-id="element-1295" data-mp="5ywstgmdv0q3">
              One of the most distressing side effects. Usually caused by rapid
              weight loss and inadequate protein/nutrient intake, not the
              medication itself.
            </p>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-1296" data-mp="1hgemfna92jyw">
              <p className="text-[11px] text-[#3B3B3B] leading-[1.6]" data-id="element-1297" data-mp="1dbyme2nbi6rl">
                <strong className="text-tealslate" data-id="element-1298" data-mp="a2m1dgwsd1nw">Prevention:</strong> Adequate
                protein is non-negotiable. Supplementing with biotin, iron,
                zinc, and collagen can also support follicle health.
              </p>
            </div>
          </div>

          <div data-id="element-1299" data-mp="o1lnohwtt4gw">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3" data-id="element-1300" data-mp="o23to69aix20">
              Muscle Loss
            </h2>
            <p className="text-xs text-[#7A7A70] leading-[1.8] mb-4" data-id="element-1301" data-mp="3nhieqswy1d1u">
              Without resistance training, up to 40% of weight lost can come
              from muscle. This lowers your metabolism and makes weight regain
              more likely.
            </p>
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4" data-id="element-1302" data-mp="52pxdho39a8c">
              <p className="text-[11px] text-[#3B3B3B] leading-[1.6]" data-id="element-1303" data-mp="54ub0rbshnlt">
                <strong className="text-tealslate" data-id="element-1304" data-mp="34pg35vz5smyg">Prevention:</strong> Adequate
                protein + weight lifting. This is why weight lifting is one of
                the 5 essentials.
              </p>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-end gap-6" data-id="element-1305" data-mp="2w9gsx29ru7w3">
          <div className="flex-1" data-id="element-1306" data-mp="2w9qjos2n4j2u">
            <SupplementCallout title="Hair and Recovery Support" description="Biotin, collagen peptides, and a quality multivitamin support hair health and recovery during rapid weight loss." data-id="element-1307" data-mp="2s7ltk3bei4ky" />
          </div>
          <div className="flex-1 bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex items-center justify-between" data-id="element-1308" data-mp="2ia7qd5ehncal">
            <div data-id="element-1309" data-mp="2dh68qpmwcynb">
              <h3 className="font-serif text-sm text-[#1F1F1F] mb-1" data-id="element-1310" data-mp="2dgmpn5lig47p">
                Need a Program?
              </h3>
              <p className="text-[10px] text-[#7A7A70] leading-[1.5] max-w-[180px]" data-id="element-1311" data-mp="24i1brnqzhdd9">
                A structured resistance training program is the single most
                effective tool.
              </p>
            </div>
            <div className="w-10 h-10 border border-[#D8D8D0] bg-white flex items-center justify-center shrink-0" data-id="element-1312" data-mp="1ujlhjbwntnzj">
              <span className="text-[8px] font-bold text-[#7A7A70]" data-id="element-1313" data-mp="3unfmurdqhdhe">QR</span>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}